<app-generic-header [goBack] = "goBack.bind(this)" [title]="'titleThemeSettings' | translate" variant="back">
</app-generic-header>

<ion-content>
  <ion-list>
    <ion-radio-group [(ngModel)]="theme" (ionChange)="setTheme(theme)">
      <ion-list-header>
        <ion-label class="theme">{{'updateThemeSettings' | translate}}</ion-label>
      </ion-list-header>
      <ion-item>
        <ion-label>{{'lightMode' | translate}}</ion-label>
        <ion-radio slot="end" value="light"></ion-radio>
      </ion-item>

      <ion-item>
        <ion-label>{{'darkMode' | translate}}</ion-label>
        <ion-radio slot="end" value="dark"></ion-radio>
      </ion-item>

      <ion-item>
        <ion-label>{{'useDeviceSettings' | translate}}</ion-label>
        <ion-radio slot="end" value="system"></ion-radio>
      </ion-item>
    </ion-radio-group>
  </ion-list>
</ion-content>
